import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import type { PluginButtonProps } from './PluginButton';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';

export function LazyPluginButton({
  board,
  plugin,
  pluginBoardButton,
  togglePluginListPopover,
  openPluginSettings,
  el,
  pluginId,
  onHeader,
  enabledHeaderButton,
  isGrouped,
  isFirst,
}: PluginButtonProps) {
  const PluginButton = useLazyComponent(
    () => import(/* webpackChunkName: "plugin-button" */ './PluginButton'),
    {
      preload: false,
      namedImport: 'PluginButton',
    },
  );
  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-ecosystem',
          feature: 'Pup Header Buttons',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <PluginButton
            pluginId={pluginId}
            board={board}
            plugin={plugin}
            pluginBoardButton={pluginBoardButton}
            el={el}
            onHeader={onHeader}
            enabledHeaderButton={enabledHeaderButton}
            isGrouped={isGrouped}
            isFirst={isFirst}
            openPluginSettings={openPluginSettings}
          />
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
}
